import { Controller } from "@hotwired/stimulus"

const PARAMS = ["gclid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
const COOKIE_NAME = "q_attribution"
const COOKIE_MAX_AGE = 60 * 60 * 24 * 90 // 90 days

export default class extends Controller {
  connect() {
    const url = new URL(window.location.href)
    const captured = {}

    for (const key of PARAMS) {
      const value = url.searchParams.get(key)
      if (value) captured[key] = value
    }

    if (Object.keys(captured).length === 0) return

    captured.captured_at = new Date().toISOString()

    const value = encodeURIComponent(JSON.stringify(captured))
    const secure = window.location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `${COOKIE_NAME}=${value}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax${secure}`
  }
}
